import { BillTypes, ListParams } from 'models';
import request from './axiosClient';
import { AxiosResponse } from 'axios';
const BILL_TABLE = '/bills-table-detail';
const URL_BILL_DETAIL = '/bill-detail-public';
const URL_BILL = '/bills-public';

export function getBillTableAPI(params: ListParams): Promise<AxiosResponse<BillTypes[]>> {
  return request({
    url: BILL_TABLE,
    method: 'get',
    params,
    noNeedToken: true,
  });
}

export function addProductToBillAPI(
  data: any,
  params: { app_name: string }
): Promise<AxiosResponse<any>> {
  return request({
    url: URL_BILL_DETAIL,
    method: 'post',
    data,
    params,
    noNeedToken: false,
  });
}

export function updateBillAPI(id: number, data: any, params: { app_name: string }) {
  return request({
    url: `${URL_BILL}/${id}`,
    method: 'put',
    params,
    data: { ...data, appName: 'pos_qr_table' },
    noNeedToken: false,
  });
}
